import React from 'react';
import * as R from 'ramda';
import { withNamespaces } from 'react-i18next';
import HelpIcon from '@material-ui/icons/Help';
import InfoIcon from '@material-ui/icons/Info';
import { withStyles } from '@material-ui/styles';
import { Badge, Grid, IconButton, ButtonBase } from '@material-ui/core';
import GlobalSetting from 'appModule/globalSetting';
import Notification from 'appModule/chat/notification';
import GlobalNotification from 'appModule/globalNotification';
import AppLanguagePreferenceLogo from 'dataModule/assets/img/AppLanguagePreference.png';
import HomeButton from './HomeButton';
import DialogDisclaimer from '../components/DialogDisclaimer';
import DialogSessionTimeOutComponent from './DialogSessionTimeOut';
import DialogCustomerSupportContactComponent from './DialogCustomerSupportContact';
import DialogAppLanguagePreference from './DialogAppLanguagePreference';

/* The 70px height is a contract: WithSidebar offsets its content by 75px and
   Sidebar pins itself to top:75px. Keep the bar one line tall at every width —
   shrink the contents rather than letting it wrap and push into the page. */
const styles = (theme) => ({
  containerWrapper: {
    backgroundColor: '#fff',
    padding: '0px 30px 0px 20px',
    height: '70px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    background: 'inherit',
    zIndex: 999,
    webkitBoxShadow: '0 3px 5px rgba(57, 63, 72, 0.3)',
    mozBoxShadow: '0 3px 5px rgba(57, 63, 72, 0.3)',
    boxShadow: '0 3px 5px rgba(57, 63, 72, 0.3)',
    width: '100%',
    // Without this the 50px of horizontal padding is added to a 100% width and
    // the bar overflows the viewport, giving the whole page a horizontal scroll.
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '0px 8px 0px 8px',
    },
  },
  // Left cluster: allowed to shrink and clip so the action icons always survive.
  brandGroup: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    overflow: 'hidden',
  },
  pullRight: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    marginRight: '55px',
    [theme.breakpoints.down('md')]: {
      marginRight: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: '0px',
    },
  },
  actionIcon: {
    fontSize: '40px',
    color: '#9e9e9e',
    marginRight: '15px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '28px',
      marginRight: '0px',
      padding: '6px',
    },
  },
  actionIconTight: {
    fontSize: '40px',
    color: '#9e9e9e',
    marginRight: '5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '28px',
      marginRight: '0px',
      padding: '6px',
    },
  },
  languageButton: {
    marginLeft: '20px',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      marginLeft: '8px',
    },
  },
  badge: {
    backgroundColor: '#ff5100',
    color: 'white',
    marginRight: '5px',
    marginTop: '3px'
  },
});

@withNamespaces('common', { wait: true })
@withStyles(styles, { index: 1 })
export default class HeaderComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openAppLanguagePreferenceDialog: false,
      openDialogCustomerSupportContact: false,
      openDialogDisclaimer: false,
      disclaimerBadge: 1,
    };
  }

  componentDidMount() {
    if (localStorage) {
      const showDisclaimerBadge = localStorage.getItem('showDisclaimerBadge');
      if (!showDisclaimerBadge) {
        localStorage.setItem('showDisclaimerBadge', 'show');
        this.setState({ disclaimerBadge: 1 });
      } else if (showDisclaimerBadge == 'hidden') {
        this.setState({ disclaimerBadge: 0 });
      } else if (showDisclaimerBadge == 'show') {
        this.setState({ disclaimerBadge: 1 });
      }
    }
  }

  toggleAppLanguagePreferenceDialog = async (open) => {
    this.setState({ openAppLanguagePreferenceDialog: open });
  };

  toggledialogCustomerSupportContact = async (open) => {
    this.setState({ openDialogCustomerSupportContact: open });
  };

  toggleDisclaimerDialog = async (open) => {
    if (open && this.state.disclaimerBadge !== 0 && localStorage) {
      localStorage.setItem('showDisclaimerBadge', 'hidden');
      this.setState({ disclaimerBadge: 0 });
    }
    this.setState({ openDialogDisclaimer: open });
  };

  render() {
    const {
      t,
      isOnBoard,
      classes: { containerWrapper, pullRight, badge, brandGroup, actionIcon, actionIconTight, languageButton },
      hideComponents = { isDisclaimer: false }
    } = this.props;

    const { ENABLE_LANGUAGE_TRANSLATION } = window.MILO_CONFIG;
    const customContainerStyle = R.pathOr({}, ['style', 'customContainerStyle'])(this.props);

    return (
      <div className={[containerWrapper]} style={customContainerStyle}>
        <div className={brandGroup}>
          <HomeButton {...this.props} />
          {ENABLE_LANGUAGE_TRANSLATION &&
            (
              <React.Fragment>
                <ButtonBase className={languageButton} onClick={() => this.toggleAppLanguagePreferenceDialog(true)} disableRipple>
                  <img src={AppLanguagePreferenceLogo} width={32} height={32} />
                </ButtonBase>
                <DialogAppLanguagePreference
                  open={this.state.openAppLanguagePreferenceDialog}
                  toggleAppLanguagePreferenceDialog={this.toggleAppLanguagePreferenceDialog}
                />
              </React.Fragment>)
          }
        </div>

        <div className={pullRight}>
          <DialogCustomerSupportContactComponent
            open={this.state.openDialogCustomerSupportContact}
            toggledialogCustomerSupportContact={this.toggledialogCustomerSupportContact}
          />
          <DialogDisclaimer
            open={this.state.openDialogDisclaimer}
            toggleDisclaimerDialog={this.toggleDisclaimerDialog}
          />

          {!hideComponents.isDisclaimer && <Grid item onClick={() => this.toggleDisclaimerDialog(true)}>
            <IconButton title={t('disclaimerDialog.tooltip')} className={actionIcon}>
              <Badge badgeContent={this.state.disclaimerBadge} classes={{ badge }} max={1000}>
                <InfoIcon style={{ width: '1em', height: '1em', fontSize: 'inherit' }} />
              </Badge>
            </IconButton>
          </Grid>}

          {!isOnBoard && <GlobalNotification />}
          <Grid item onClick={() => this.toggledialogCustomerSupportContact(true)}>
            <IconButton title={t('customerServiceSupportDialog.tooltip')} className={actionIconTight}>
              <HelpIcon style={{ width: '1em', height: '1em', fontSize: 'inherit' }} />
            </IconButton>
          </Grid>

          {!isOnBoard && <GlobalSetting />}
        </div>

        {!isOnBoard && <Notification />}
        {!isOnBoard && <DialogSessionTimeOutComponent />}
      </div>
    );
  }
}
